module.exports = __webpack_public_path__ + "img/big_eye_chart03.d4fde3b2.jpg";